//# imask
// import './modules/imask.js'

//# menuBurger
// import './modules/menuBurger.js'

//# tips
// import './modules/tips.js'

//# dropdown
// import './modules/dropdown.js'

//# scrollTo
// import smoothscroll from 'smoothscroll-polyfill'
// smoothscroll.polyfill()
// import './modules/scrollTo.js'

//# spoiler
// import './modules/spoiler.js'

// # sliders
// import './modules/sliders.js'

//# rating
// import './modules/rating.js'

//# select
// import './modules/select.js'

//# dynamic adaptive
// import './modules/dynamicAdaptive.js'

//# fixedHeader
// import './modules/fixedHeader.js'

//# range
// import './modules/range.js'

//# resizeInput
// import './modules/resizeInput.js'

//# quantity
// import './modules/quantity.js'

//# tips
// import './modules/tips.js'

//# tabs
// import './modules/tabs.js'

//# popups
// import './modules/popups.js'

//# moreText
// import './modules/moreText.js'

//# adaptiveSearch
// import './modules/adaptiveSearch.js'

//# youtube-embed
// import 'lite-youtube-embed'

//# zoomImage
// import './modules/zoomImage.js'

//# marquee
// import './modules/marquee.js'

//# my script
import './script.js'

//# LIBRARIES
//# gsap
// import './modules/gsap.js'

// Initialize
// const myAtropos = Atropos({
//   el: '.my-atropos',
//   alwaysActive: true,
//   activeOffset: 20,
//   rotateTouch: false,
//   rotateXMax: 8,
//   rotateYMax: 4,
//   // shadow: false,
//   highlight: false,
//   shadowOffset: 50,
//   shadowScale: 0.95,
// })

const $content = document.querySelector('.about-6__content')
const $side = document.querySelector('.about-6__side')

const mediaQuery = window.matchMedia(`(min-width: ${991.98 / 16}rem)`)

if ($content && $side && mediaQuery.matches) {
  gsap.to($side, {
    scrollTrigger: {
      trigger: $side,
      start: 'top-=145 top',
      end: `+=${$content.offsetHeight - $side.offsetHeight}`,
      pin: true,
      pinSpacing: false,
    },
  })
}
